"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var with_state_1 = require("../../misc/with-state");
var modal_1 = __importDefault(require("../../plugins/modal"));
var ProductDetailsStoreLocatorApp = /** @class */ (function (_super) {
    __extends(ProductDetailsStoreLocatorApp, _super);
    function ProductDetailsStoreLocatorApp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isModalOpen: false,
        };
        _this.fetchAndInsertStoreLocatorHTML = function () { return __awaiter(_this, void 0, void 0, function () {
            var el, html;
            return __generator(this, function (_a) {
                el = this.storeLocatorRef.current;
                // we have to retry because React Modal children won't necessarily be available, even after mount
                // https://github.com/reactjs/react-modal/issues/338
                if (!el) {
                    setTimeout(this.fetchAndInsertStoreLocatorHTML, 1);
                    return [2 /*return*/];
                }
                html = document.getElementById('store-locator-html');
                if (!html) {
                    throw new Error('missing #store-locator-html');
                }
                el.appendChild(html);
                html.style.display = 'block';
                return [2 /*return*/];
            });
        }); };
        _this.handleOpenModalClick = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { isModalOpen: true })); }); };
        _this.handleOpenModalClose = function () { return _this.setState(function (state) { return (__assign(__assign({}, state), { isModalOpen: false })); }); };
        _this.storeLocatorRef = React.createRef();
        return _this;
    }
    ProductDetailsStoreLocatorApp.prototype.componentDidMount = function () {
        this.fetchAndInsertStoreLocatorHTML();
    };
    ProductDetailsStoreLocatorApp.prototype.render = function () {
        var _a, _b, _c, _d;
        var modalStyle = { content: { maxWidth: '75rem', width: '95%' } };
        var walmartUnavailable = (_a = window.productDetailStoreLocatorSettings) === null || _a === void 0 ? void 0 : _a.walmartUnavailable;
        var selectedVariant = this.props.selectedVariantStore.variant;
        var walmartVariantURL = selectedVariant ? (_b = window.productDetailStoreLocatorSettings) === null || _b === void 0 ? void 0 : _b.variantURLs[selectedVariant.id] : null;
        var walmartURL = walmartVariantURL || 'https://www.walmart.com/cp/hello-bello/8825382';
        return (React.createElement("div", null,
            React.createElement("div", null,
                !walmartUnavailable && (React.createElement(React.Fragment, null,
                    React.createElement("a", { className: 'h6-7', href: walmartURL, target: '_blank' },
                        "Buy on ",
                        React.createElement("u", null, "Walmart.com")),
                    React.createElement("br", null),
                    ' ')),
                React.createElement("a", { className: 'h6-7', onClick: this.handleOpenModalClick },
                    walmartUnavailable ? 'Find' : 'or find',
                    " ",
                    React.createElement("u", null, "your nearest store"))),
            React.createElement(modal_1.default, { isOpen: this.state.isModalOpen, handleClose: this.handleOpenModalClose, style: modalStyle },
                React.createElement("div", { ref: this.storeLocatorRef }),
                React.createElement("div", { className: 'grid-x align-middle text-center font-bold h4 margin-bottom-0' },
                    !walmartUnavailable && (React.createElement("div", { className: 'bg-contain cell medium-6 padding-vertical-6 medium-padding-vertical-8 bg-koromiko', style: { backgroundImage: "url(".concat((_c = window.productDetailStoreLocatorSettings) === null || _c === void 0 ? void 0 : _c.yellowBgImg, ")") } },
                        React.createElement("a", { className: 'text-white', href: walmartURL, target: '_blank' },
                            "Buy on ",
                            React.createElement("u", null, "Walmart.com")))),
                    React.createElement("div", { className: (0, classnames_1.default)({ 'bg-contain cell  padding-vertical-6 medium-padding-vertical-8 bg-light-wisteria': true, 'medium-6': !walmartUnavailable }), style: { backgroundImage: "url(".concat((_d = window.productDetailStoreLocatorSettings) === null || _d === void 0 ? void 0 : _d.purpleBgImg, ")") } },
                        React.createElement("a", { className: 'text-white', onClick: this.handleOpenModalClose },
                            "Continue on ",
                            React.createElement("u", null, "HelloBello")))))));
    };
    return ProductDetailsStoreLocatorApp;
}(React.Component));
var ProductDetailsStoreLocator = (0, with_state_1.WithSelectedVariantStore)(ProductDetailsStoreLocatorApp);
exports.default = ProductDetailsStoreLocator;
